export interface IInbox {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  userId: string;
  targetId: string;
  type: InboxType;
  isFavorite: boolean;
  metadata: IInboxMetadata;
  isRead: boolean;
}

export enum InboxType {
  SPECIFICATION_INVITE = "SPECIFICATION_INVITE",
  SUPPLIER_SPECIFICATION_INVITE = "SUPPLIER_SPECIFICATION_INVITE",
  SUPPLIER_SPECIFICATION_INVITE_STARTED = "SUPPLIER_SPECIFICATION_INVITE_STARTED",
  SUPPLIER_SPECIFICATION_INVITE_COMPLETED = "SUPPLIER_SPECIFICATION_INVITE_COMPLETED",
  SPECIFICATION_EXPLORE_MATCHED_PRODUCT_COMPLETED = "SPECIFICATION_EXPLORE_MATCHED_PRODUCT_COMPLETED",//1
  SPECIFICATION_EXPLORE_USER_AND_COMMENT_COMPLETED = "SPECIFICATION_EXPLORE_USER_AND_COMMENT_COMPLETED", //2
  SPECIFICATION_EXPLORE_LOCAL_PARTNER_SUPPORT_COMPLETED = "SPECIFICATION_EXPLORE_LOCAL_PARTNER_SUPPORT_COMPLETED", // 3
  SPECIFICATION_EXPLORE_COMPETITIVE_INDEX_COMPLETED = "SPECIFICATION_EXPLORE_COMPETITIVE_INDEX_COMPLETED", // 4
  SPECIFICATION_EXPLORE_PRODUCER_SCORE_COMPLETED = "SPECIFICATION_EXPLORE_PRODUCER_SCORE_COMPLETED", // 5
  PRODUCT_EXPLORE = "PRODUCT_EXPLORE",
  PRODUCT_COMPARE = "PRODUCT_COMPARE",
  SPECIFICATION_CREATED = "SPECIFICATION_CREATED",
  SPECIFICATION_UPDATED = "SPECIFICATION_UPDATED",
  SPECIFICATION_DELETED = "SPECIFICATION_DELETED",
}

export interface IInboxMetadata {
  hash: string;
  user: IUser;
  email: string;
  product: IProduct;
  categories: string[];
  specification: ISpecification;
  itemCount: number;
  sendedBy: IUser;
  receivedBy: IUser;
}

export interface IProduct {
  id: string;
  logo: string;
  name: string;
  createdAt: string;
}

export interface IUser {
  id: string;
  name: string | null;
  email: string;
}

export interface ISpecification {
  companyId: string;
  id: string;
  name: string;
  createdAt: string;
  hash: string;
  itemCount: number;
}

export interface IActivity {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  userId: string | null;
  targetId: string;
  type: ActivityType;
  metadata: IActivityMetadata;
}

export interface IActivityMetadata {
  specification?: ISpecification;
  sendedBy: IUser;
  receivedBy: IUser;
  createdBy: IUser;
}

export enum ActivityType {
  PRODUCT_EXPLORE = "PRODUCT_EXPLORE",
  PRODUCT_COMPARE = "PRODUCT_COMPARE",
  SPECIFICATION_INVITE = "SPECIFICATION_INVITE",
  SPECIFICATION_CREATED = "SPECIFICATION_CREATED",
  SPECIFICATION_UPDATED = "SPECIFICATION_UPDATED",
  SPECIFICATION_DELETED = "SPECIFICATION_DELETED",
}
